import { useAuth } from "@babackapp/auth-client/hooks";
import { useSearchParams } from "react-router-dom";

// Single source of truth for the merchant-preview check (gates the merchant-only
// PositionSelector in components/layout.tsx): a logged-in baback-office user, or
// the `?advanced=true` debug flag. Reads via react-router so it also works under
// the widget's HashRouter (where the query lives in the hash, not location.search).
export function useIsMerchant(): boolean {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const isAdvanced = searchParams.get("advanced") === "true";
  return !!user || isAdvanced;
}
